import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  BackgroundBlur,
  CloseButton,
  CloseButtonContainer,
  CloseModalButton,
  Container,
  Item,
  ItemLabel,
  ItemsContainer,
  Modal,
  ModalContent,
  ModalCTAs,
  ModalDescription,
  ModalInfo,
  ModalTitle,
} from './css';
import { PrintingLabels } from '../../../utils/enums';
import { routes } from '../../../utils/constants';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import cancelOrder from './api';
import { apiDownloadBol, apiDownloadPdfLabel } from '../../../services/documents';

const ActionsMenu = ({
  isMenuOpen, closeMenu, probillNumber, orderId, postalZipCode, status, pickupDone, shipmentNumber,
}) => {
  const itemsContainerRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    title: '',
    description: '',
    cta: {
      label: '',
      onClick: () => { },
      disabled: false,
    },
    closeLabel: '',
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (itemsContainerRef.current && !itemsContainerRef.current.contains(event.target) && !isModalOpen) {
        closeMenu();
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [closeMenu, isModalOpen]);

  const handleModifyModal = () => {
    setModalData({
      title: t('Alert'),
      description: t('ModifyAlert'),
      cta: {
        label: t('Modify'),
        onClick: () => window.open(`${routes.createShipment}?recreate=true&update=true&probillNumber=${orderId}&shipmentNumber=${shipmentNumber}`),
      },
      closeLabel: t('Cancel'),
    });
    setIsModalOpen(true);
  };

  const handleCancelOrder = () => {
    cancelOrder(postalZipCode, orderId).then((res) => {
      setModalData(res);
    });
  };

  const handleCancelModal = () => {
    setModalData({
      title: t('Alert'),
      description: t('CancelAlert'),
      cta: {
        label: t('ConfirmCancel'),
        onClick: () => handleCancelOrder(),
      },
      closeLabel: t('CloseCancelAlert'),
    });
    setIsModalOpen(true);
  };

  const openBol = () => apiDownloadBol(probillNumber);

  const openLabelSM = () => apiDownloadPdfLabel(probillNumber, PrintingLabels.SM);

  const openLabelLG = () => apiDownloadPdfLabel(probillNumber, PrintingLabels.LG);

  return (
    <Container isopen={isMenuOpen.toString()}>
      <ItemsContainer ref={itemsContainerRef}>
        <CloseButtonContainer>
          <CloseButton onClick={closeMenu}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                            // eslint-disable-next-line max-len
                d="M2.28033 1.21967C1.98744 0.926777 1.51256 0.926777 1.21967 1.21967C0.926777 1.51256 0.926777 1.98744 1.21967 2.28033L2.28033 1.21967ZM17.7197 18.7803C18.0126 19.0732 18.4874 19.0732 18.7803 18.7803C19.0732 18.4874 19.0732 18.0126 18.7803 17.7197L17.7197 18.7803ZM18.7803 2.28033C19.0732 1.98744 19.0732 1.51256 18.7803 1.21967C18.4874 0.926777 18.0126 0.926777 17.7197 1.21967L18.7803 2.28033ZM1.21967 17.7197C0.926777 18.0126 0.926777 18.4874 1.21967 18.7803C1.51256 19.0732 1.98744 19.0732 2.28033 18.7803L1.21967 17.7197ZM1.21967 2.28033L9.46967 10.5303L10.5303 9.46967L2.28033 1.21967L1.21967 2.28033ZM9.46967 10.5303L17.7197 18.7803L18.7803 17.7197L10.5303 9.46967L9.46967 10.5303ZM17.7197 1.21967L9.46967 9.46967L10.5303 10.5303L18.7803 2.28033L17.7197 1.21967ZM9.46967 9.46967L1.21967 17.7197L2.28033 18.7803L10.5303 10.5303L9.46967 9.46967Z"
                fill="black"
              />
            </svg>
          </CloseButton>
        </CloseButtonContainer>
        {!pickupDone
          ? (
            <Item onClick={openBol}>
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                        // eslint-disable-next-line max-len
                  d="M9.53685 14.2633C9.8124 14.4871 10.2072 14.4871 10.4827 14.2633L14.1539 11.2805C14.4753 11.0193 14.5242 10.5469 14.263 10.2254C14.0018 9.90395 13.5295 9.85509 13.208 10.1163L10.7598 12.1054L10.7598 1.75C10.7598 1.33579 10.424 1 10.0098 1C9.59558 1 9.25979 1.33579 9.25979 1.75L9.25979 12.1054L6.81161 10.1163C6.49013 9.85509 6.01778 9.90395 5.75658 10.2254C5.49538 10.5469 5.54424 11.0193 5.86572 11.2805L9.53685 14.2633ZM1.75 17.49C1.33579 17.49 1 17.8258 1 18.24C1 18.6542 1.33579 18.99 1.75 18.99H18.2701C18.6843 18.99 19.0201 18.6542 19.0201 18.24C19.0201 17.8258 18.6843 17.49 18.2701 17.49H1.75Z"
                  fill="black"
                />
              </svg>
              <ItemLabel>{t('DownloadBOL')}</ItemLabel>
            </Item>
          )
          : null}
        {!pickupDone
          ? (
            <Item onClick={openLabelSM}>
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                        // eslint-disable-next-line max-len
                  d="M9.53685 14.2633C9.8124 14.4871 10.2072 14.4871 10.4827 14.2633L14.1539 11.2805C14.4753 11.0193 14.5242 10.5469 14.263 10.2254C14.0018 9.90395 13.5295 9.85509 13.208 10.1163L10.7598 12.1054L10.7598 1.75C10.7598 1.33579 10.424 1 10.0098 1C9.59558 1 9.25979 1.33579 9.25979 1.75L9.25979 12.1054L6.81161 10.1163C6.49013 9.85509 6.01778 9.90395 5.75658 10.2254C5.49538 10.5469 5.54424 11.0193 5.86572 11.2805L9.53685 14.2633ZM1.75 17.49C1.33579 17.49 1 17.8258 1 18.24C1 18.6542 1.33579 18.99 1.75 18.99H18.2701C18.6843 18.99 19.0201 18.6542 19.0201 18.24C19.0201 17.8258 18.6843 17.49 18.2701 17.49H1.75Z"
                  fill="black"
                />
              </svg>
              <ItemLabel>{t('DownloadLabelsSM')}</ItemLabel>
            </Item>
          )
          : null}
        {!pickupDone
          ? (
            <Item onClick={openLabelLG}>
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                        // eslint-disable-next-line max-len
                  d="M9.53685 14.2633C9.8124 14.4871 10.2072 14.4871 10.4827 14.2633L14.1539 11.2805C14.4753 11.0193 14.5242 10.5469 14.263 10.2254C14.0018 9.90395 13.5295 9.85509 13.208 10.1163L10.7598 12.1054L10.7598 1.75C10.7598 1.33579 10.424 1 10.0098 1C9.59558 1 9.25979 1.33579 9.25979 1.75L9.25979 12.1054L6.81161 10.1163C6.49013 9.85509 6.01778 9.90395 5.75658 10.2254C5.49538 10.5469 5.54424 11.0193 5.86572 11.2805L9.53685 14.2633ZM1.75 17.49C1.33579 17.49 1 17.8258 1 18.24C1 18.6542 1.33579 18.99 1.75 18.99H18.2701C18.6843 18.99 19.0201 18.6542 19.0201 18.24C19.0201 17.8258 18.6843 17.49 18.2701 17.49H1.75Z"
                  fill="black"
                />
              </svg>
              <ItemLabel>{t('DownloadLabelsLG')}</ItemLabel>
            </Item>
          )
          : null}

        <Item onClick={() => window.open(`${routes.createShipment}?recreate=true&probillNumber=${orderId}&shipmentNumber=${shipmentNumber}`)}>
          <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                        // eslint-disable-next-line max-len
              d="M5.77214 1.99023C5.6032 1.99023 5.44229 2.0625 5.32985 2.18888L2.15029 5.76267C2.05349 5.87147 2 6.01215 2 6.15793V15.0805C2 15.4085 2.26531 15.6744 2.59258 15.6744H7.19572C7.52299 15.6744 7.7883 15.4085 7.7883 15.0805C7.7883 14.7525 7.52299 14.4866 7.19572 14.4866H3.18517V6.75183H13.4464V8.64931C13.4464 8.97731 13.7117 9.24321 14.039 9.24321C14.3663 9.24321 14.6316 8.97731 14.6316 8.64931V6.15793C14.6316 6.01215 14.5781 5.87147 14.4813 5.76267L11.3017 2.18888C11.1893 2.0625 11.0284 1.99023 10.8594 1.99023H5.77214ZM7.72321 5.56402H3.91492L6.0377 3.17804H7.72321V5.56402ZM8.90837 5.56402V3.17804H10.5939L12.7167 5.56402H8.90837ZM12.6983 10.61C12.8107 10.4836 12.9716 10.4113 13.1406 10.4113H18.2278C18.3968 10.4113 18.5577 10.4836 18.6701 10.61L21.7437 14.0647C21.8966 14.1502 22 14.3137 22 14.5013V23.5956C22 23.8717 21.7761 24.0956 21.5 24.0956H9.86842C9.59228 24.0956 9.36842 23.8717 9.36842 23.5956V23.5056L9.36841 23.5016V14.579L9.36842 14.5751V14.5013C9.36842 14.3137 9.47176 14.1502 9.62463 14.0647L12.6983 10.61ZM14.5641 22.9077C14.6375 22.9077 14.7078 22.9211 14.7727 22.9456H20.85V17.2725C20.8272 17.2094 20.8148 17.1413 20.8148 17.0704V15.1729H10.5536V22.9077H14.5641ZM11.2833 13.9851H15.0916V11.5991H13.4061L11.2833 13.9851ZM16.2768 11.5991V13.9851H20.0851L17.9623 11.5991H16.2768Z"
              fill="black"
            />
          </svg>
          <ItemLabel>{t('Duplicate')}</ItemLabel>
        </Item>

        {(status !== 'UnderReview' && status !== 'Delivered') && (
        <Item onClick={handleModifyModal}>
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                        // eslint-disable-next-line max-len
              d="M1 2.77383C1 2.39931 1.28631 2.0957 1.63949 2.0957H12.7454C13.0986 2.0957 13.3849 2.39931 13.3849 2.77383C13.3849 3.14835 13.0986 3.45196 12.7454 3.45196H2.27897V17.7394H14.721V9.27328C14.721 8.89876 15.0073 8.59515 15.3605 8.59515C15.7137 8.59515 16 8.89876 16 9.27328V18.4176C16 18.7921 15.7137 19.0957 15.3605 19.0957H1.63949C1.28631 19.0957 1 18.7921 1 18.4176V2.77383Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                        // eslint-disable-next-line max-len
              d="M16.4822 4.20668L15.9319 3.64496L10.3388 9.23805L10.0555 10.078L10.8889 9.79994L16.4822 4.20668ZM11.4349 10.5514L9.01851 11.3576C8.88952 11.4006 8.73542 11.2434 8.77925 11.1135L9.60045 8.67884L16.6427 1.63661C17.5889 1.21252 18.8388 2.39911 18.5098 3.40918L18.4772 3.5092L11.4349 10.5514ZM17.7335 2.95536L16.992 3.69683L16.4417 3.13512L17.1903 2.38656C17.4744 2.33695 17.7966 2.6605 17.7335 2.95536Z"
              fill="black"
            />
          </svg>
          <ItemLabel>{t('Modify')}</ItemLabel>
        </Item>
        )}

        {(status !== 'UnderReview' && status !== 'Delivered') && (
        <Item onClick={handleCancelModal}>
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                        // eslint-disable-next-line max-len
              d="M17.65 10.0957C17.65 14.3207 14.225 17.7457 10 17.7457C5.77502 17.7457 2.35 14.3207 2.35 10.0957C2.35 5.87072 5.77502 2.4457 10 2.4457C14.225 2.4457 17.65 5.87072 17.65 10.0957ZM19 10.0957C19 15.0663 14.9706 19.0957 10 19.0957C5.02944 19.0957 1 15.0663 1 10.0957C1 5.12514 5.02944 1.0957 10 1.0957C14.9706 1.0957 19 5.12514 19 10.0957ZM6.53168 6.6275C6.70741 6.45176 6.99234 6.45176 7.16807 6.6275L10.0001 9.45955L12.832 6.62771C13.0077 6.45197 13.2926 6.45197 13.4684 6.62771C13.6441 6.80345 13.6441 7.08837 13.4684 7.26411L10.6365 10.0959L13.4682 12.9276C13.6439 13.1033 13.6439 13.3882 13.4682 13.564C13.2924 13.7397 13.0075 13.7397 12.8318 13.564L10.0001 10.7323L7.16829 13.5642C6.99255 13.7399 6.70763 13.7399 6.53189 13.5642C6.35616 13.3884 6.35616 13.1035 6.53189 12.9278L9.36373 10.0959L6.53168 7.26389C6.35594 7.08816 6.35594 6.80323 6.53168 6.6275Z"
              fill="black"
            />
          </svg>
          <ItemLabel>{t('Cancel')}</ItemLabel>
        </Item>
        )}

      </ItemsContainer>
      <BackgroundBlur />
      {isModalOpen
                && (
                <Modal>
                  <ModalContent>
                    <CloseModalButton onClick={() => setIsModalOpen(false)}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                                // eslint-disable-next-line max-len
                          d="M2.28033 1.21967C1.98744 0.926777 1.51256 0.926777 1.21967 1.21967C0.926777 1.51256 0.926777 1.98744 1.21967 2.28033L2.28033 1.21967ZM17.7197 18.7803C18.0126 19.0732 18.4874 19.0732 18.7803 18.7803C19.0732 18.4874 19.0732 18.0126 18.7803 17.7197L17.7197 18.7803ZM18.7803 2.28033C19.0732 1.98744 19.0732 1.51256 18.7803 1.21967C18.4874 0.926777 18.0126 0.926777 17.7197 1.21967L18.7803 2.28033ZM1.21967 17.7197C0.926777 18.0126 0.926777 18.4874 1.21967 18.7803C1.51256 19.0732 1.98744 19.0732 2.28033 18.7803L1.21967 17.7197ZM1.21967 2.28033L9.46967 10.5303L10.5303 9.46967L2.28033 1.21967L1.21967 2.28033ZM9.46967 10.5303L17.7197 18.7803L18.7803 17.7197L10.5303 9.46967L9.46967 10.5303ZM17.7197 1.21967L9.46967 9.46967L10.5303 10.5303L18.7803 2.28033L17.7197 1.21967ZM9.46967 9.46967L1.21967 17.7197L2.28033 18.7803L10.5303 10.5303L9.46967 9.46967Z"
                          fill="black"
                        />
                      </svg>
                    </CloseModalButton>
                    <ModalInfo>
                      <ModalTitle>{modalData.title}</ModalTitle>
                      {modalData.description
                                && <ModalDescription>{modalData.description}</ModalDescription>}
                    </ModalInfo>
                    <ModalCTAs>
                      <SecondaryButton showArrow={false} onClick={() => setIsModalOpen(false)}>{modalData.closeLabel}</SecondaryButton>
                      {modalData.cta
                                && <PrimaryButton onClick={modalData.cta.onClick}>{modalData.cta.label}</PrimaryButton>}
                    </ModalCTAs>
                  </ModalContent>
                </Modal>
                )}
    </Container>
  );
};

ActionsMenu.propTypes = {
  isMenuOpen: PropTypes.bool,
  closeMenu: PropTypes.func,
  probillNumber: PropTypes.string,
  orderId: PropTypes.string,
  postalZipCode: PropTypes.string,
  status: PropTypes.string,
  pickupDone: PropTypes.bool,
  shipmentNumber: PropTypes.string,
};

export default ActionsMenu;
